import { Toast } from "vant";
import QRCode from "qrcode";
import domtoimage from "dom-to-image";

export const mixins = {
  data() {
    return {
      urlList: [
        {
          url: "https://jhni8.cwuxt.com/lld666/user.html?dc=dxtg",
          name: "%E8%90%9D%E8%8E%89%E5%B2%9B",
        },
        {
          url: "https://8uy7.w4r9c.com/hjll/user.html?dc=dxtg",
          name: "%E6%B5%B7%E8%A7%92%E7%A4%BE%E5%8C%BA",
        },
        {
          url: "https://jhni8.d7ps0.com/haose/user.html?dc=dxtg",
          name: "Mr.HS",
        },
        {
          url: "https://bbhs.g1x5d.com/bus/user.html?dc=dxtg",
          name: "%E5%AE%9D%E5%AE%9D%E5%B7%B4%E5%A3%AB",
        },
        {
          url: "https://s3e4.4o8if.com/91lq/user.html?dc=dxtg",
          name: "91%E7%8C%8E%E5%A5%87",
        },
        {
          url: "https://ahuy7.8tp5h.com/yjdm/user.html?dc=dxtg",
          name: "%E5%A6%96%E7%B2%BE%E5%8A%A8%E6%BC%AB",
        },
        {
          url: "https://jhni8.z6pg5.com/nut/user.html?dc=dxtg",
          name: "NUT",
        },
        {
          url: "https://jhni8.ghi34.com/91aw/user.html?dc=dxtg",
          name: "91%E6%9A%97%E7%BD%91",
        },
        {
          url: "https://jhni8.qo6w9.com/qysq/user.html?dc=dxtg",
          name: "%E5%A6%BB%E5%8F%8B",
        },
        {
          url: "https://s8u7.b56am.com/51ll/user.html?dc=dxtg",
          name: "51%E4%BC%A6%E7%90%86",
        },
        {
          url: "https://jhni8.e4j1o.com/smtt/user.html?dc=dxtg",
          name: "%E6%B6%A9%E6%BC%AB%E5%A4%A9%E5%A0%82",
        },
        {
          url: "https://dhccnwp0f9cbz.cloudfront.net/?dc=dxtg",
          name: "%E5%A5%BD%E8%89%B2%E8%AF%BE%E5%A0%82",
        },
        {
          url: "https://jhni8.wb2h0.com/nais/user.html?dc=dxtg",
          name: "%E5%A5%B6%E6%80%9D",
        },
        {
          url: "https://jhni8.7du2h.com/hls/user.html?dc=dxtg",
          name: "%E9%BB%91%E6%96%99%E7%A4%BE",
        },
        {
          url: "https://jhni8.bf9x7.com/awjd/user.html?dc=dxtg",
          name: "%E6%9A%97%E7%BD%91%E7%A6%81%E5%9C%B0",
        },
        {
          url: "https://jhni8.o94td.com/tiktok/user.html?dc=dxtg",
          name: "TIKTOK",
        },
      ], // 域名数组
      showPopup: false, // 菜单弹窗
      showImgPopup: false, // 分享图片弹窗
      qrImg: undefined, // 二维码
    };
  },
  mounted() {
    this.addressUrl = window.location.host;
    this.$nextTick(() => {
      this.init();
    });
  },
  methods: {
    init() {
      QRCode.toDataURL(this.addressUrl, {
        width: 38,
        margin: 1,
        maskPattern: 1,
        scale: 1,
        color: {
          dark: "#000",
          light: "rgba()",
        },
      }).then((url) => {
        this.qrImg = url;
      });
    },
    jumpUrl(url) {
      window.open(url);
    },
    doCopy() {
      let req = this.addressUrl;
      this.$copyText(req).then(
        () => {
          Toast("复制成功");
          this.showPopup = false;
        },
        () => {
          Toast("复制失败");
        }
      );
    },
    saveImage() {
      domtoimage.toJpeg(this.$refs.saveImage).then((dataUrl) => {
        var link = document.createElement("a");
        link.download = "share.jpeg";
        link.href = dataUrl;
        link.click();
        Toast("保存成功");
      });
    },
  },
};
